import React from 'react';

import { DropResult } from 'react-beautiful-dnd';

type Props = {
  onDragEnd: (result: DropResult) => void;
  testType: string;
};

const OptionGroupsTestReorder: React.FC<Props> = ({ onDragEnd, testType }) => {
  const handleClick = (): void => {
    const response = {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      source: {
        index: 0,
        droppableId: 'abc123'
      },
      type: testType === 'variant-success' ? 'OPTION' : 'OPTION_GROUP'
    };

    if (testType === 'success' || testType === 'variant-success') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      response.destination = {
        index: 1,
        droppableId: 'abc123'
      };
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    onDragEnd(response);
  };

  return (
    <button data-testid="optionGroups-test-reorder" type="button" onClick={handleClick}>
      Test
    </button>
  );
};

export default OptionGroupsTestReorder;
